

class PathHelper {
	static VALUATION_PATH: string = "valuate"
	static AREA_ANALYSIS_PATH: string = "area"

	static getPath() {
		let path = window.location.pathname
		if (path.includes("/")) {
			return path.split("/")[1]
		}
		return path
	}
}

export default PathHelper